export { default } from './FullSpecification';
